import { Space, Tabs } from 'antd';
import React from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AddLegalCustomer from './customerAdditionForms/AddLegalCustomer';
import AddPhysicalCustomer from './customerAdditionForms/AddPhysicalCustomer';
import useTranslation from '../../../hooks/translation/useTranslation';

function AddCustomers() {
  const { trans } = useTranslation();
  const navigate = useNavigate();

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <ArrowLeftOutlined style={{ fontSize: '20px' }} onClick={() => navigate('/admin/customers')} />
      <Tabs
        defaultActiveKey="1"
        items={[
          {
            label: trans('physical_person'),
            key: '1',
            children: <AddPhysicalCustomer />,
          },
          {
            label: trans('legal_person'),
            key: '2',
            children: <AddLegalCustomer />,
          },
        ]}
      />
    </Space>
  );
}

export default AddCustomers;
